module.exports = __webpack_public_path__ + "static/hero-img-alex-2b99cab20586b6341f69a37c146c2437.png";